<template>
  <div>
    <div>
      <!-- {{checklistValue.fieldId}} -->
      <label v-if="checklistValue.fieldType == 8">
        <span style="white-space: pre">
          {{ checklistValue.value }}
        </span>
      </label>
      <b-form-group
        v-else
        :label="getLabel"
        :label-for="'input-pendency-value' + checklistValue.id.toString()"
        label-cols-sm="5"
        label-cols-md="5"
        label-cols-lg="5"
      >
        <b-input-group v-if="checklistValue.fieldType == 10">
          <div v-if="checklistValue.hasAttachment">
            <b-button
              v-if="!isShowingAttachment"
              size="sm"
              @click="showAttachment()"
            >
              {{ $t("geral.showAttachments") }}
            </b-button>
            <b-button
              v-if="isShowingAttachment"
              size="sm"
              @click="hideAttachment()"
            >
              {{ $t("geral.hideAttachments") }}
            </b-button>
          </div>
        </b-input-group>
        <b-input-group v-else>
          <!-- Booleano -->
          <b-form-select
            v-if="checklistValue.fieldType == 1"
            :id="'input-pendency-value' + checklistValue.id.toString()"
            v-model="checklistValue.value"
            :name="'input-pendency-value' + checklistValue.id.toString()"
            value="true"
            unchecked-value="false"
            disabled
            :options="optionsBoolean"
          ></b-form-select>

          <!-- Data -->
          <b-form-input
            v-if="checklistValue.fieldType == 2"
            type="date"
            :id="'input-pendency-value' + checklistValue.id.toString()"
            v-model="checklistValue.value"
            readonly
          />

          <!-- Hora -->
          <b-form-input
            v-if="checklistValue.fieldType == 3"
            type="time"
            :id="'input-pendency-value' + checklistValue.id.toString()"
            v-model="checklistValue.value"
            readonly
          />

          <!-- Decimal -->
          <b-form-input
            v-if="checklistValue.fieldType == 4"
            type="text"
            :id="'input-pendency-value' + checklistValue.id.toString()"
            v-model="checklistValue.value"
            v-mask="'money'"
            readonly
          />

          <!-- Inteiro -->
          <b-form-input
            v-if="checklistValue.fieldType == 5"
            type="text"
            :id="'input-pendency-value' + checklistValue.id.toString()"
            v-model="checklistValue.value"
            v-mask="'999999999999999'"
            readonly
          />

          <!-- Texto -->
          <b-form-input
            v-if="checklistValue.fieldType == 6"
            type="text"
            :id="'input-pendency-value' + checklistValue.id.toString()"
            v-model="checklistValue.value"
            readonly
          />

          <!-- Lista -->
          <b-form-input
            v-if="checklistValue.fieldType == 7"
            type="text"
            :id="'input-pendency-value' + checklistValue.id.toString()"
            v-model="checklistValue.value"
            readonly
          />

          <b-form-input
            v-if="checklistValue.fieldType == 9"
            type="text"
            :id="'input-pendency-value' + checklistValue.toString()"
            v-model="checklistValue.value"
            readonly
          />

          <b-input-group-append v-if="checklistValue.hasAttachment">
            <b-button v-if="!isShowingAttachment" @click="showAttachment">
              <i class="tim-icons icon-attach-87"></i>
            </b-button>
            <b-button v-if="isShowingAttachment" @click="hideAttachment">
              <i class="tim-icons icon-attach-87"></i>
            </b-button>
          </b-input-group-append>
        </b-input-group>
      </b-form-group>
    </div>
    <div v-if="isShowingAttachment">
      <b-row align-h="end">
        <b-col md="7">
          <b-row align-h="end">
            <b-col
              v-for="(attachment, rowAttachment) in checklistValue.attachments"
              :key="rowAttachment"
              md="6"
            >
              <base-attachment-viewer
                class="ml-3 mb-3"
                :attachment="attachment"
                :discard-visible="false"
              ></base-attachment-viewer>
              <!-- <base-attachment-item
                :attachment="attachment.attachment"
                :discard-visible="false"
              >
              </base-attachment-item> -->
            </b-col>
          </b-row>
        </b-col>
      </b-row>
      <b-row
        v-if="
          checklistValue.attachments == null ||
          checklistValue.attachments.lenght == 0
        "
      >
        <b-col lg="5" md="5" sm="12"></b-col>
        <b-col>
          <base-attachment-viewer
            class="ml-3 mb-3"
            :attachment="attachment"
            :discard-visible="false"
          ></base-attachment-viewer>
          <!-- <base-attachment-item
            :attachment="checklistValue.attachment"
            :discard-visible="false"
          >
          </base-attachment-item> -->
        </b-col>
      </b-row>
    </div>

    <fullscreen-sidebar ref="fullscreenSidebar">
      <template v-slot:content>
        <div class="fullscreen-container">
          <img
            class="fullscreen-image align-middle d-block mx-auto"
            :src="fullscreenAttachment"
          />
        </div>
      </template>
    </fullscreen-sidebar>
    <!-- <div>{{checklist}}</div> -->
  </div>
</template>

<script>
import AwesomeMask from "awesome-mask";
// import BaseAttachmentItem from "@/components_rms/base/BaseAttachmentItem.vue";
import FullscreenSidebar from "@/components_rms/FullscreenSidebar.vue";
import BaseAttachmentViewer from "@/components_rms/base/BaseAttachmentViewer.vue";

export default {
  name: "PendencyDetailsChecklistValue",
  props: {
    checklistValue: Object,
    label: String,
  },
  components: {
    // BaseAttachmentItem,
    FullscreenSidebar,
    BaseAttachmentViewer,
  },
  directives: {
    mask: AwesomeMask,
  },
  data: function () {
    return {
      fullscreenAttachment: "",
      optionsBoolean: [
        { value: true, text: "Sim" },
        { value: false, text: "Não" },
      ],
      isShowingAttachment: false,
    };
  },
  created: function () {},
  computed: {
    getLabel() {
      if (this.label && this.label.length > 0) return this.label;
      if (this.checklistValue) return this.checklistValue.fieldName;
      return ";";
    },
  },
  methods: {
    hideAttachment() {
      if (!this.checklistValue) return;
      if (!this.checklistValue.hasAttachment) return;
      this.isShowingAttachment = false;
      this.$emit("after-attachment-show");
    },
    showAttachment() {
      if (!this.checklistValue) return;
      if (!this.checklistValue.hasAttachment) return;

      this.isShowingAttachment = true;
      this.$emit("after-attachment-show");

      if (!this.isShowingAttachment) return;
      if (this.checklistValue.attachment) return;

      this.$apiChecklist
        .request({
          url:
            "/checklist/getimageattachment/" +
            this.checklistValue.id.toString(),
          method: "GET",
          responseType: "arraybuffer", //important
        })
        .then((response) => {
          this.checklistValue.attachment = window.URL.createObjectURL(
            new Blob([response.data], {
              type: response.headers["content-type"],
            })
          );
        })
        .catch((error) => {
          console.log(error);
          console.log(error.response.data.errors);
          if (error.response.status == 400) {
            console.log(error.response.data.errors);
          }
        });
    },
    openImage(attachment) {
      this.fullscreenAttachment = attachment;
      this.$refs.fullscreenSidebar.open();
    },
  },
};
</script>
